import { FunctionalComponent, VNode, h } from '@stencil/core';
import { Position } from '../../core/types/globalTypes';
import { isNullOrUndefined } from 'utils/collection';

interface AdsTooltipContentProps {
  content: string | HTMLSlotElement;
  isActive: boolean;
  id: string;
  position: Position;
  width: string;
}

export const AdsTooltipContent: FunctionalComponent<AdsTooltipContentProps> = ({ content, isActive, id, position, width }) => {
  const clickHandler = function (evt: Event): void {
    evt.stopPropagation();
  };

  return isActive
    ? ((
        <div
          style={!isNullOrUndefined(width) ? { width: width } : null}
          id={id}
          class={`c-tooltip__content is-${position} ${width !== '100%' ? 'has-no-max-width' : ''}`}
          aria-live={`${isActive ? 'assertive' : 'polite'}`}
          onClick={clickHandler}
        >
          {content}
        </div>
      ) as VNode)
    : null;
};
